// Simple in-memory cache with TTL (Time To Live)
class Cache {
  constructor(defaultTTL = 5 * 60 * 1000) { // 5 minutes default
    this.cache = new Map();
    this.defaultTTL = defaultTTL;
  }

  set(key, value, ttl = this.defaultTTL) {
    const expiry = Date.now() + ttl;
    this.cache.set(key, { value, expiry });
  }

  get(key) {
    const item = this.cache.get(key);
    if (!item) return null;

    if (Date.now() > item.expiry) {
      this.cache.delete(key);
      return null;
    }

    return item.value;
  }

  has(key) {
    const item = this.cache.get(key);
    if (!item) return false;

    if (Date.now() > item.expiry) {
      this.cache.delete(key);
      return false;
    }

    return true;
  }

  clear() {
    this.cache.clear();
  }

  delete(key) {
    this.cache.delete(key);
  }

  size() {
    return this.cache.size;
  }
}

// Export singleton instances with different TTLs
export const licenseCache = new Cache(5 * 60 * 1000); // 5 minutes TTL for license data
export const userCache = new Cache(3 * 60 * 1000); // 3 minutes for user data
export const analyticsCache = new Cache(10 * 60 * 1000); // 10 minutes for analytics
export const generalCache = new Cache(5 * 60 * 1000); // 5 minutes default

export default Cache;
